module.exports = "/assets/images/plus_455a75.svg";